import "./styles.css";
import displayController from "./displayController.js";

displayController.initialize();